function LoaderComponent() {
  return (
    <div
      style={{ height: "400px" }}
      className="w-100  d-flex align-items-center justify-content-center"
    >
      <div className=" spinner-border primary-color" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}

export default LoaderComponent;
